import { Component, type ReactNode, type ReactElement, type ErrorInfo } from 'react';
import type { CaughtError } from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { AuthenticationError } from '@atlassian/jira-standard-errors/src/common/utils/authentication-error/index.tsx';

export type AuthenticationErrorBoundaryProps = {
	children: ReactNode;
	render: () => ReactElement;
};

type State = {
	caughtError: CaughtError | null;
};

export class AuthenticationErrorBoundary extends Component<
	AuthenticationErrorBoundaryProps,
	State
> {
	state = { caughtError: null };

	componentDidCatch(error: Error, info: ErrorInfo) {
		if (error instanceof AuthenticationError) {
			this.setState({ caughtError: { error, info } });
			return;
		}
		throw error;
	}

	render() {
		const { caughtError } = this.state;
		const { children, render: renderFallback } = this.props;

		if (!caughtError) {
			return children;
		}

		return renderFallback();
	}
}
